import { Injectable } from '@angular/core'
import { Lead, leadsPath } from '@parkupp/core'
import { addDoc, collection, collectionSnapshots, deleteDoc, doc, docSnapshots, Firestore, orderBy, query, serverTimestamp, updateDoc } from '@angular/fire/firestore'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { GlobalService } from './global.service'

@Injectable({
    providedIn: 'root',
})
export class LeadsService {
    constructor(
        public firestore: Firestore,
        private globalService: GlobalService
    ) {}

    createLead(lead: Lead): Promise<any> {
        const leadData = JSON.parse(JSON.stringify(lead))
        leadData.createdAt = serverTimestamp()
        leadData.updatedAt = serverTimestamp()
        // Include enterprise source - defaults to 'parkupp' if not on an enterprise domain
        leadData.denormEnterpriseKey = this.globalService.enterpriseKey || 'parkupp'
        return addDoc(collection(this.firestore, leadsPath()), leadData)
    }

    updateLead(lead: Lead, leadKey: string): Promise<void> {
        const leadData = JSON.parse(JSON.stringify(lead))
        leadData.updatedAt = serverTimestamp()
        return updateDoc(doc(this.firestore, leadsPath(), leadKey), leadData)
    }

    deleteLead(leadKey: string): Promise<void> {
        return deleteDoc(doc(this.firestore, leadsPath(), leadKey))
    }

    subscribeToLead(leadKey: string): Observable<Lead> {
        return docSnapshots(doc(this.firestore, leadsPath(), leadKey)).pipe(
            map((document) => {
                if (document.exists()) {
                    const lead = new Lead(document.data())
                    lead.$key = document.id
                    return lead
                } else {
                    throw new Error('Lead not found')
                }
            })
        )
    }

    subscribeToLeads(): Observable<Lead[]> {
        return collectionSnapshots(query(collection(this.firestore, leadsPath()), orderBy('createdAt', 'desc'))).pipe(
            map((documents) => {
                const leads: Lead[] = []
                documents.forEach((document) => {
                    const lead = new Lead(document.data())
                    lead.$key = document.id
                    leads.push(lead)
                })
                return leads
            })
        )
    }

    subscribeToLeadsWithLocation(): Observable<Lead[]> {
        return this.subscribeToLeads().pipe(map((leads) => leads.filter((lead) => lead.latitude && lead.longitude)))
    }
}
